import { css } from 'styled-components';
import { BREAKPOINTS } from '../tokens';

type BreakpointKey = Lowercase<keyof typeof BREAKPOINTS>;

type BreakpointFunction = (
  strings: TemplateStringsArray,
  ...interpolations: Array<any>
) => ReturnType<typeof css>;

type BreakpointsMap = {
  [key in BreakpointKey]: BreakpointFunction;
};

/**
 * Mixin: Create 'min-width' media query.
 * Usage example:
 *  ```jsx
 *  .myclass {
 *      font-size: 1rem;
 *
 *      ${breakpoint.md`
 *          font-size: 2rem;
 *      `}
 *
 *      ${breakpoint.lg`
 *          font-size: 3rem;
 *      `}
 *  }
 *  ```
 */
export const breakpoint: BreakpointsMap = Object.keys(BREAKPOINTS).reduce((acc, key) => {
  const px = BREAKPOINTS[key as Uppercase<BreakpointKey>];

  acc[key.toLocaleLowerCase() as BreakpointKey] = (strings, ...interpolations) => css`
      @media (min-width: ${px}px) {
        ${css(strings, ...interpolations)}
      }
    `;

  return acc;
}, {} as BreakpointsMap);
